export const DAILY_TOKEN_CACHE_KEY = "daily-token";

export class UserNotRegisteredTokenError extends Error {}
